import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 gap-4 sm:gap-6 lg:gap-8" }
const _hoisted_2 = { class: "card col-span-2 lg:col-span-1" }
const _hoisted_3 = { class: "px-4 py-5 sm:px-6 bg-white relative overflow-hidden" }
const _hoisted_4 = { class: "px-4 py-5 sm:p-6" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = { class: "card col-span-2 lg:col-span-1" }
const _hoisted_7 = { class: "px-4 py-5 sm:px-6 bg-white relative overflow-hidden" }
const _hoisted_8 = { class: "px-4 py-5 sm:p-6" }
const _hoisted_9 = { class: "font-bold" }
const _hoisted_10 = { key: 0 }

import {
		store as useStore
	} from "@/store/user"

	// vue
	import {
		ref
	} from 'vue'

	
	const __default__ = { name: 'MyProfile' } // name the component

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	// store
	const store = useStore()
	const firstName = ref(store.user.cognitoUser.attributes.given_name)
	const lastName = ref(store.user.cognitoUser.attributes.family_name)
	// const phones = store.user.phoneNumbers
	const phones = ref("")
	const email = ref(store.user.cognitoUser.attributes.email)
	const company = ref(store.user.cognitoUser.attributes["custom:company"])
	const address1 = ref(JSON.parse(store?.user?.cognitoUser?.attributes?.address || "{}").street_address.split("\n")[0])
	const address2 = ref(JSON.parse(store?.user?.cognitoUser?.attributes?.address || "{}").street_address.split("\n")[1])
	const city = ref(JSON.parse(store?.user?.cognitoUser?.attributes?.address || "{}").locality)
	const state = ref(JSON.parse(store?.user?.cognitoUser?.attributes?.address || "{}").region)
	const zip = ref(JSON.parse(store?.user?.cognitoUser?.attributes?.address || "{}").postal_code)

return (_ctx: any,_cache: any) => {
  const _component_card_header_backdrop = _resolveComponent("card-header-backdrop")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w-full mb-5 flex justify-between" }, [
      _createElementVNode("h1", { class: "text-3xl font-black text-dbBlue" }, " My Profile ")
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "card-heading" }, " Contact Information ", -1)),
          _createVNode(_component_card_header_backdrop, { class: "opacity-30" })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(firstName.value + " " + lastName.value), 1),
          _createElementVNode("p", null, _toDisplayString(email.value), 1),
          _createElementVNode("p", null, _toDisplayString(phones.value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "card-heading" }, " Company Information ", -1)),
          _createVNode(_component_card_header_backdrop, { class: "opacity-30" })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, _toDisplayString(company.value), 1),
          _createElementVNode("div", null, [
            _createElementVNode("p", null, _toDisplayString(address1.value), 1),
            (address2.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(address2.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("p", null, _toDisplayString([[city.value, state.value].filter(Boolean).join(", "), zip.value].filter(Boolean).join(" ")), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})